import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const adminAxios = (code) =>
  axios.create({
    baseURL: API,
    headers: { "X-Admin-Code": code },
  });

export const ASSETS = {
  // Real Globo Dancing photos
  heroInterior: "https://customer-assets.emergentagent.com/job_dancing-trappes/artifacts/xluqcq33_WhatsApp%20Image%202026-04-26%20at%2022.44.56.jpeg",
  diningRoom: "https://customer-assets.emergentagent.com/job_dancing-trappes/artifacts/k12wiz4h_WhatsApp%20Image%202026-04-26%20at%2022.44.55%20%281%29.jpeg",
  bar: "https://customer-assets.emergentagent.com/job_dancing-trappes/artifacts/w2amjzk0_WhatsApp%20Image%202026-04-26%20at%2022.44.56%20%281%29.jpeg",
  facade: "https://customer-assets.emergentagent.com/job_dancing-trappes/artifacts/d6rmcihx_WhatsApp%20Image%202026-04-26%20at%2022.44.54.jpeg",
  tableDetail: "https://customer-assets.emergentagent.com/job_dancing-trappes/artifacts/yx53redz_WhatsApp%20Image%202026-04-26%20at%2022.44.55.jpeg",
  // Stock food photos (replace once user provides real dish photos)
  bacalhau: "https://images.unsplash.com/photo-1764333580740-b327847301b1",
  pasteis: "https://images.unsplash.com/photo-1698414639176-2fb25b481239",
  // Aliases (back-compat with existing pages)
  family: "https://customer-assets.emergentagent.com/job_dancing-trappes/artifacts/k12wiz4h_WhatsApp%20Image%202026-04-26%20at%2022.44.55%20%281%29.jpeg",
  festive: "https://customer-assets.emergentagent.com/job_dancing-trappes/artifacts/w2amjzk0_WhatsApp%20Image%202026-04-26%20at%2022.44.56%20%281%29.jpeg",
};

export const CATEGORY_LABELS = {
  entrees: "Entrées",
  plats_du_jour: "Plats du jour",
  plats: "Plats portugais",
  desserts: "Desserts",
  boissons: "Boissons",
  vins: "Vins & Porto",
};

export const CATEGORY_ORDER = [
  "entrees",
  "plats_du_jour",
  "plats",
  "desserts",
  "boissons",
  "vins",
];
